import { Button, Spin } from "antd";
import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { dentalIcons } from "../../utils-icons/dentalIcons";

const CustomDeleteButton = ({
  title = "Submit Case",
  isLoading = false,
  onClick,
  type,
  width = 160,
  icon,
  leadingIcon = false,
  isDisbale = false,
  isPm = false,
  isRound = false,
  isHeight = false,
}) => {
  return (
    <Button
      disabled={isDisbale}
      style={{
        backgroundColor: "#D4183D",
        height: isHeight ? 36 : 43,
        borderRadius: isRound ? 8 : 5,
        minWidth: width,
        color: "white",
        fontSize: 16,
        fontFamily: "Poppins-Medium",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClick}
    >
      {leadingIcon && icon && <img src={icon} style={{ marginRight: 10 }} />}
      {isLoading ? (
        <Spin
          indicator={<LoadingOutlined spin />}
          size="large"
          style={{ color: "white" }}
        />
      ) : (
        title
      )}
      {!leadingIcon && icon && (
        <img src={icon} style={{ marginLeft: 10, marginBottom: 3 }} />
      )}
    </Button>
  );
};

export default CustomDeleteButton;
